module.exports = __webpack_public_path__ + "images/Medallia-a9df0d.png";